import type { SVGProps } from 'react'
const SvgSyChatSearchLight = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M9.5 5C7.02 5 5 7.02 5 9.5v8c0 .823.678 1.5 1.5 1.5h8a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-8a.493.493 0 0 1-.5-.5v-8C6 7.561 7.561 6 9.5 6h5C16.439 6 18 7.561 18 9.5v2a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-2C19 7.02 16.98 5 14.5 5z" />
		<path
			fillOpacity={0.24}
			d="M7.5 9.9a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h7a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6zm0 3a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h5a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6z"
		/>
		<path d="M16.5 13c-1.375 0-2.5 1.125-2.5 2.5s1.125 2.5 2.5 2.5 2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5m0 1c.834 0 1.5.666 1.5 1.5s-.666 1.5-1.5 1.5-1.5-.666-1.5-1.5.666-1.5 1.5-1.5m2.146 3.646a.5.5 0 0 0 0 .708l1.5 1.5a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.708l-1.5-1.5a.5.5 0 0 0-.708 0" />
	</svg>
)
export default SvgSyChatSearchLight
